import { render, staticRenderFns } from "./CompanyMenuFoodOrderDialog.vue?vue&type=template&id=1ea4ae80"
import script from "./CompanyMenuFoodOrderDialog.vue?vue&type=script&lang=js"
export * from "./CompanyMenuFoodOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports